import { library } from '@fortawesome/fontawesome-svg-core'
import { faGithub } from '@fortawesome/free-brands-svg-icons'
// import { } from '@fortawesome/free-regular-svg-icons'
import { faCog, faLock, faSearch,faSignOutAlt, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import Vue from 'vue'

library.add(faUser, faLock, faSignOutAlt, faCog, faGithub, faSearch)

Vue.component('Fa', FontAwesomeIcon)
